import { render, staticRenderFns } from "./wxwl-tejia.vue?vue&type=template&id=bb8397ca"
import script from "./wxwl-tejia.vue?vue&type=script&lang=js"
export * from "./wxwl-tejia.vue?vue&type=script&lang=js"
import style0 from "./wxwl-tejia.vue?vue&type=style&index=0&id=bb8397ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports